export default __webpack_public_path__ + "static/media/community-icon.b53688a1.svg";